import { ListingOfferCardSmall } from 'app/components/listing-offer-card.small';
import { type useAllTags, type ClosestListingsByTag } from 'app/network/listing';
import { ListingListWithStrategy } from 'app/screens/billboard/all-listings/components/recommended-listings';
import { Strategies } from 'app/screens/billboard/all-listings/components/recommended-listings.utils';

export function LandingInterestRecommendationsBlock({
  onOpenOfferTag,
  recommendations,
  tags,
}: {
  onOpenOfferTag: (tagId: string) => void;
  recommendations: ClosestListingsByTag[];
  tags: Awaited<ReturnType<typeof useAllTags>>['data'];
}) {
  return (
    <>
      {recommendations.map((recommendation) => (
        <ListingListWithStrategy
          key={recommendation.tagId}
          strategyProps={{ strategy: Strategies.YourInterest }}
          recommendationState={{ recommendations: recommendation.listings, isPending: false, show: true }}
          recommendations={recommendation.listings}
          titleSuffix={tags?.find((tag) => tag.id === recommendation.tagId)?.tagName}
          onViewAll={() => onOpenOfferTag(recommendation.tagId)}
          card={ListingOfferCardSmall}
        />
      ))}
    </>
  );
}
